/// <reference path="../invoices/InvoiceLineCell.ts" />

class QuotationLineCell extends InvoiceLineCell 
{
    // Override methods as needed for quotation-specific functionality
    
    // Example: If you need to customize the behavior for quotation line items
    // awakeFromHTML() {
    //     super.awakeFromHTML();
    //     // Quotation-specific initialization
    // }
    
    // If you need to override how line items are displayed or calculated
    // updateUI() {
    //     super.updateUI();
    //     // Quotation-specific UI updates
    // }
}
